import res from './res'

res.add('en', {
    title: 'The page is under construction',
    description: 'Our experts are working, everything will work soon'
})
